import { useQuery } from '@tanstack/react-query';
import { contextService } from '../services/context.service';
import type { ListRecordsResponse, ContextItem } from '../services/context.service';

export function useContextList(options?: {
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    filters = {},
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<ContextItem>>({
    queryKey: ['contextitems', page, pageSize, filters],
    queryFn: () => contextService.find({ page, pageSize, filters }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useContextById(id: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<ContextItem>({
    queryKey: ['context', id],
    queryFn: () => contextService.findById(id),
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
